export default "__VITE_ASSET__DGGLYX4P__"